export const recipes = {
  "rice-bowl": {
    title: "Rice Bowl",
    image: "/images/rice-bowl.jpg",
    proteins: ["chicken", "beef", "tofu", "edamame"],
    vegetables: ["corn", "carrot", "cabbage", "raddish"],
    starchs: ["basmati", "sushi rice", "quinoa"],
    ingredients: [
      "15ml soy sauce",
      "20g brown sugar",
      "80ml water",
      "1 clove garlic",
      "1 tsp cornflower",
      "mayo",
      "1/2 lemon",
      "1 tsp rice vinegar",
      "coriander",
    ],
    steps: [
      "Put you chosen starch on to cook, once done put to the side.",
      "Mix soy sauce, brown sugar, water in a pot and bring to the boil.",
      "Let simmer for 3mins, mix in crushed garlic and cornflour, stir until mixed, put to the side.",
      "Cook your chosen protein, once done, toss in sauce.",
      "Prepare vegetables, and mix with mayo (to your taste), lemon, vinegar, salt and pepper.",
      "Assemble components and sprinkle with chopped coriander.",
    ],
  },
  pasta: {
    title: "Pasta",
    image: "/images/spaghetti.jpg",
    proteins: [
      "minced chicken",
      "minced beef",
      "minced turkey",
      "plantbased mince",
    ],
    vegetables: [
      "carrot",
      "zuchinni",
      "celery",
      "mushrooms",
      "squash",
      "capsicum",
    ],
    starchs: ["spaghetti", "edamame pasta", "pasta", "gnocchi"],
    ingredients: [
      "olive oil",
      "onion",
      "dried oregano",
      "dried basil",
      "dried rosemary",
      "stock",
      "canned tomatoes",
      "garlic",
    ],
    steps: [
      "Brown onion in oil.",
      "Add your protein and cook through.",
      "Add herbs, stock, garlic, and canned tomatoes",
      "Cook pasta until almost cooked",
      "Add pasta to sauce and cook until done",
    ],
  },
  "butter-chicken": {
    title: "Butter Chicken",
    image: "/images/butter-chicken.jpeg",
    proteins: [
      "chicken",
      "meat-free chicken bites",
      "paneer",
      "tofu",
      "chickpeas",
    ],
    vegetables: ["potato", "onion", "tomato", "green beans", "mushrooms"],
    starchs: [
      "basmati",
      "brown rice",
      "bulgar wheat",
      "jasmine rice",
      "quinoa",
    ],
    ingredients: [
      "cardamom pods",
      "coconut cream",
      "corriander",
      "curry powder",
      "garlic cloves",
      "ginger",
      "paprika",
      "soya cream",
      "tomato paste",
      "vegetable stock",
    ],
    steps: [
      "Cook the starch",
      "Peel and finely chop garlic and ginger",
      "Chop your vegetables",
      "Soften onion and tomato in a pan if you're using them",
      "Add garlic, ginger, curry powder and paprika to the pan",
      "Add your remaning vegetables after a few minutes",
      "Dissolve coconut cream, tomato paste and vegetable stock in some boiled water",
      "Add stock and soya cream to the pan. This is your sauce.",
      "Fry protein an another pan and when ready, add to the sauce",
      "Serve on top of you starch of choice",
    ],
  },
  stirfry: {
    title: "Sticky Chilli Stirfry",
    image: "/images/stirfry.jpeg",
    proteins: ["beef", "tofu", "pork", "meat-free mince"],
    vegetables: [
      "baby corn",
      "bamboo shoot",
      "capsicum",
      "carrot",
      "green beans",
    ],
    starchs: ["basmati", "long grain rice", "brown rice"],
    ingredients: [
      "chilli jam pot",
      "garlic",
      "ginger",
      "rice vinegar",
      "sesame oil",
      "soy sauce",
      "spring onion",
      "toasted sesame rice",
    ],
    steps: [
      "Cook your rice",
      "Cook your protein with some cooking oil in a large pan",
      "While the protein is cooking, cut up your vegetables",
      "When your protein is browned, add the vegetables to the pan",
      "Make your sticky chili sauce by mixing the following in a small bowl - the rice vinegar, soy sauce, sesame oil and chili jam bowl",
      "Once the vegetables are almost cooked, add ginger and garlic and cook until fragrant",
      "Add the sticky chili sauce and cook until everything is coated and sticky",
      "Serve with sesame seeds and sliced spring onion over your starch of choice",
    ],
  },
  tandoori: {
    title: "Tandoori Salad",
    image: "/images/tandoori-salad.jpeg",
    proteins: ["white fish", "tofu", "vegetarian fish alternative"],
    vegetables: ["corn", "peas", "raddish", "cucumber", "tomato"],
    starchs: ["basmati", "bulgar wheat", "quinoa", "long grain rice"],
    ingredients: [
      "shallot",
      "nigella seeds",
      "mint sauce",
      "curry powder",
      "natural yoghurt",
      "dried chili flakes",
    ],
    steps: [
      "Cook your starch with a pinch of salt and the nigella seeds",
      "Preheat your grill and cut your protein into byte-sized pieces",
      "Combine half your yoghurt with curry powder and chili flakes in a bowl. Coat your protein in this sauce.",
      "Bake your protein for 7 minutes",
      "Cut your vegetables up (if using cucumber, remove the seeds for later) and mix in a bowl with a pinch of salt to make your salad",
      "Combine yoghurt, mint and cucumber seeds if you have them along with salt",
      "Serve protein, salad and sauce together",
    ],
  },
  burger: {
    title: "Burger",
    image: "/images/burger.jpeg",
    proteins: ["chicken patty", "beef patty", "plant-based patty"],
    vegetables: ["lettuce", "tomato", "cucumber", "red onion", "pineapple"],
    starchs: ["sweet potatoes", "potatoes", "parsnip"],
    ingredients: ["red onion", "buns", "brown sugar", "mayo", "siracha"],
    steps: [
      "Cut your starch into chip shape and cook in a 220 degree oven for 25-30mins.",
      "Caramalise finely sliced onions in a pan with olive oil, sugar, and salt.",
      "Cook your patty.",
      "Combine mayo with siracha.",
      "Prepare vegetables for burger.",
      "Toast buns, then assemble burger with caramalised onions.",
    ],
  },
};
